export default __webpack_public_path__ + "static/media/time.ebc8dc6e.png";